import { h, render } from "preact";
import App from "./app";
import Api from "./api";
import Theme from "./theme";

Theme.isDarkObservable.subscribe(dark =>
   console.log(dark ? "Dark Theme" : "Light Theme")
);

let u = new URL(window.location.href);
let code = u.searchParams.get("code");
if (code)
   Api.getToken(code).then(() => {
      window.history.replaceState({}, document.title, "/");
   });

render(<App />, document.body);
